import type { ActionNode } from "@repo/shared/workflow";
import type { FC } from "react";

interface ActionNodeEditorProps {
  node: ActionNode;
  onChange: (key: string, value: any) => void;
}

export const ActionNodeEditor: FC<ActionNodeEditorProps> = ({
  node,
  onChange,
}) => {
  return (
    <div className="space-y-4">
      This is the action node editor
      {/* <pre>{JSON.stringify(node, null, 2)}</pre> */}
    </div>
  );
};
